import React, { Fragment } from 'react';
import { useHistory, Switch } from 'react-router-dom';
import Protected from './ProtectedRoute';
import Sidebar from '../Components/Header/sidebar';
import { FeedsLoader } from '../Loader/loader';
import Main from '../Components/proctored-test/main';
import ManageSkillPath from '../Components/Admin/Manage-Skills/manageSkillPath';
import ManageTopic from '../Components/Admin/Manage-Skills/Manage-Topics/manageTopic';
import manageSubtopic from '../Components/Admin/Manage-Skills/Manage-Subtopic/manageSubtopic';
import AddContent from '../Components/Admin/Manage-Skills/Manage-Add-Content/add-content';
import AddResource from '../Components/Admin/Manage-Skills/Manage-Add-Content/addResource';
import MentorV2 from '../Components/Mentors/mentor-v2';
import SkillDetails from '../Components/Learn/skill-details';
import AddQuiz from '../Components/Admin/Admin-Test/addQuiz';
import ManageSkils from '../Components/Admin/Manage-Skills/manageSkills';
const SkillLibrary = React.lazy(() => import('../Components/Skill-Library/skillLibrary'));
const Learn = React.lazy(() => import('../Components/Learn/Learn'));
const Feeds = React.lazy(() => import('../Components/Feeds/feeds'));
const TopicDetails = React.lazy(() => import('../Components/Learn/topicDetails'));
const Nofound = React.lazy(() => import('../Components/nofound'));
const Test = React.lazy(() => import('../Components/Test/test'));
const Rewards = React.lazy(() => import('../Components/Rewards/rewards'));
const Analytics = React.lazy(() => import('../Components/Analytics/analytics'));
const Profile = React.lazy(() => import('../Components/My-profile/profile'));
const MoreItems = React.lazy(() => import('../Components/More/moreItems'));
const Saved = React.lazy(() => import('../Components/Saved/saved'));
const Notification = React.lazy(() => import('../Components/Notification/notification'));
const AddSkills = React.lazy(() => import('../Components/Add-skills/addSkills'));
const AdminUsers = React.lazy(() => import('../Components/Admin/Admin-Users/users'));
const Account = React.lazy(() => import('../Components/Admin/Admin-Account/account'));
const AdminContent = React.lazy(() => import('../Components/Admin/Admin-content/adminContent'));
const JobTitle = React.lazy(() => import('../Components/Admin/Admin-JobTitles/job-title'));
const AddJobTitle = React.lazy(() => import('../Components/Admin/Admin-JobTitles/addJobTitle'));
const IndividualSkillPod = React.lazy(() => import('../Components/Saved/individualSkillPod'));
const MyContent = React.lazy(() => import('../Components/My-content/myContent'));
const AdminTest = React.lazy(() => import('../Components/Admin/Admin-Test/adminTest'));
const AdminReward = React.lazy(() => import('../Components/Admin/Admin-Reward/rewards'));
const AdminTeams = React.lazy(() => import('../Components/Admin/Admin-Users/teams'));
const SearchResult = React.lazy(() => import('../Components/SearchResults/searchResult'));
const AdminReports = React.lazy(() => import('../Components/Admin/Admin-Reports/reports'));
const Feedback = React.lazy(() => import('../Components/Review/feedback'));
const GettingStarted = React.lazy(() => import('../Components/Getting-Started/getting-started'));
const Report = React.lazy(() => import('../Components/Test/report'));
const ExternalSidebar = React.lazy(() => import('../Components/Header/externalSidebar'));
const ManageMentor = React.lazy(() => import('../Components/Admin/Manage-Mentor/manageMentor'));


export default function PrivateRoute() {
  let navigate = useHistory();

  return (
    <Fragment>
      {localStorage.getItem('role') === 'user' ?
        (JSON.parse(localStorage.getItem('profileComplete')) ?
          (JSON.parse(localStorage.getItem('score')) === null || JSON.parse(localStorage.getItem('score')) === undefined || localStorage.getItem('score') < 20) ?
            window.location.pathname === '/' && (
              navigate.push('/getting-started')) :
            window.location.pathname === '/' && (
              navigate.push('/learn'))
          :
          window.location.pathname === '/' && (
            navigate.push('/add-skills'))
        )
        :
        window.location.pathname === '/' && (
          navigate.push('/learn')
        )
      }
      {(window.location.pathname.split('/')[2] === 'skill') && <Protected component={ExternalSidebar} />}
      {(window.location.pathname === '/login' || window.location.pathname === '/external-login' || (window.location.pathname.split('/')[2] === 'skill')) ? null : <Protected component={Sidebar} />}
      <div className='layout-container' style={{ paddingLeft: (window.location.pathname === '/capture-pic' || window.location.pathname === '/learn/skill-explorer' || window.location.pathname === '/start-test' || window.location.pathname === '/test-report') ? 0 : 321 }} >
        <React.Suspense fallback={<FeedsLoader />}>
          <Switch>
            <Protected exact path="/add-skills" component={AddSkills} />
            <Protected exact path="/getting-started" component={GettingStarted} />
            <Protected exact path="/learn" component={Learn} />
            {/* <Protected exact path="/learn/skill-explorer" component={SkillExplorer} /> */}
            <Protected exact path="/learn/skill-explorer" component={SkillDetails} />
            <Protected exact path="/learn/skill" component={TopicDetails} />
            <Protected exact path="/feeds" component={Feeds} />
            <Protected exact path="/tests" component={Test} />
            <Protected exact path="/rewards" component={Rewards} />
            <Protected exact path="/analytics" component={Analytics} />
            <Protected exact path="/profile" component={Profile} />
            <Protected exact path="/my-content" component={MyContent} />
            {window.innerWidth < 767 && <Protected exact path="/more" component={MoreItems} />}
            <Protected exact path="/saved" component={Saved} />
            <Protected exact path="/saved/skill-pod" component={IndividualSkillPod} />
            <Protected exact path="/notifications" component={Notification} />
            <Protected exact path="/search" component={SearchResult} />
            <Protected exact path="/skill-library" component={SkillLibrary} />
            <Protected exact path="/users" component={AdminUsers} />
            <Protected exact path="/users/team" component={AdminTeams} />
            <Protected exact path="/account" component={Account} />
            <Protected exact path="/manage-content" component={AdminContent} />
            <Protected exact path="/job-titles" component={JobTitle} />
            <Protected exact path="/job-titles/add" component={AddJobTitle} />
            <Protected exact path="/upload" component={AddJobTitle} />
            <Protected exact path="/manage-tests" component={AdminTest} />
            <Protected exact path="/manage-tests/add" component={AddQuiz} />
            <Protected exact path="/manage-rewards" component={AdminReward} />
            <Protected exact path="/reports" component={AdminReports} />
            <Protected exact path="/start-test" component={Main} />
            <Protected exact path="/test-report" component={Report} />
            <Protected exact path="/skillpath-review" component={Feedback} />
            <Protected exact path="/manage-skills" component={ManageSkils} />
            <Protected exact path="/manage-skillpath" component={ManageSkillPath} />
            <Protected exact path="/manage-skillpath/topics" component={ManageTopic} />
            <Protected exact path="/manage-skillpath/subtopics" component={manageSubtopic} />
            <Protected exact path="/manage-skillpath/subtopic/add-content" component={AddContent} />
            <Protected exact path="/manage-skillpath/subtopic/add-content/add-resource" component={AddResource} />
            <Protected exact path="/mentors" component={MentorV2} />
            <Protected exact path='/mentors-connect' component={ManageMentor} />
            {/* <Protected exact path="/start-test" component={TestView} /> */}
            <Protected
              path="*"
              component={Nofound}
            />
          </Switch>
        </React.Suspense>
      </div>
    </Fragment >
  )
}